/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Run_CompleteInputs */

const bn_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রান সম্পূর্ণ`)
};

const de_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lauf abgeschlossen`)
};

const el_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η εκτέλεση ολοκληρώθηκε`)
};

const en_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run complete`)
};

const es_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecución completa`)
};

const fr_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partie terminée`)
};

const hi_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा चलाएँ`)
};

const hu_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Futtatás kész`)
};

const id_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan selesai`)
};

const it_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esegui completato`)
};

const ja_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実行が完了しました`)
};

const ko_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실행 완료`)
};

const nl_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltooid`)
};

const pl_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruchom kompletny`)
};

const pt_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execução concluída`)
};

const ru_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск завершен`)
};

const sv_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kör komplett`)
};

const tr_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalıştırma tamamlandı`)
};

const uk_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск завершено`)
};

const vi_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chạy hoàn tất`)
};

const zh_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运行完成`)
};

const zh_hant_game_run_complete = /** @type {(inputs: Game_Run_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運行完成`)
};

/**
* | output |
* | --- |
* | "Run complete" |
*
* @param {Game_Run_CompleteInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_run_complete = /** @type {((inputs?: Game_Run_CompleteInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Run_CompleteInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_run_complete(inputs)
	if (locale === "de") return de_game_run_complete(inputs)
	if (locale === "el") return el_game_run_complete(inputs)
	if (locale === "en") return en_game_run_complete(inputs)
	if (locale === "es") return es_game_run_complete(inputs)
	if (locale === "fr") return fr_game_run_complete(inputs)
	if (locale === "hi") return hi_game_run_complete(inputs)
	if (locale === "hu") return hu_game_run_complete(inputs)
	if (locale === "id") return id_game_run_complete(inputs)
	if (locale === "it") return it_game_run_complete(inputs)
	if (locale === "ja") return ja_game_run_complete(inputs)
	if (locale === "ko") return ko_game_run_complete(inputs)
	if (locale === "nl") return nl_game_run_complete(inputs)
	if (locale === "pl") return pl_game_run_complete(inputs)
	if (locale === "pt") return pt_game_run_complete(inputs)
	if (locale === "ru") return ru_game_run_complete(inputs)
	if (locale === "sv") return sv_game_run_complete(inputs)
	if (locale === "tr") return tr_game_run_complete(inputs)
	if (locale === "uk") return uk_game_run_complete(inputs)
	if (locale === "vi") return vi_game_run_complete(inputs)
	if (locale === "zh") return zh_game_run_complete(inputs)
	return zh_hant_game_run_complete(inputs)
});